/**
 * Tracks the last URL the user was on within the connector Library.
 * The Library calls saveLastLibraryUrl() on mount and on every filter-URL
 * change; the detail page calls readLastLibraryUrl() to populate the
 * back link.
 */

const KEY = 'lastLibraryUrl';
export const LIBRARY_FALLBACK_URL = '/connectors';

export function saveLastLibraryUrl(url: string): void {
  try {
    sessionStorage.setItem(KEY, url);
  } catch {
    /* sessionStorage may be disabled — silently no-op */
  }
}

export function readLastLibraryUrl(): string {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (typeof raw !== 'string') return LIBRARY_FALLBACK_URL;
    if (!raw.startsWith('/connectors')) return LIBRARY_FALLBACK_URL;
    return raw;
  } catch {
    return LIBRARY_FALLBACK_URL;
  }
}
